module.exports = __webpack_public_path__ + "static/img/3324_phase_function_Paper_PointsHejduk_Prediction.91ee855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3324_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 8tIl
// module chunks = 0